import { passwordLength } from "../../../constants";
import FieldInput from "../../Form/Fields/FieldInput";
import images from "../../../images";
import React, { useState } from "react";
import registerSchema from "../../Schemas/registerSchema";
import translate from "../../../Utils/translate";

const messages = [
  { passed: false, message: translate("validations.password.min", passwordLength) },
  { passed: false, message: translate("validations.password.lowercase") },
  { passed: false, message: translate("validations.password.uppercase") },
  { passed: false, message: translate("validations.password.special") },
  { passed: false, message: translate("validations.password.number") },
];

const MasterPassword = (props) => {
  const [passReq, setPassReq] = useState(messages);
  const [showMessage, setShowMessage] = useState(false);
  const [type, setType] = useState("password");

  const defaultProps = {
    autoComplete: "one-time-code",
    icon: type === "password" ? images.icons.eyeOpen : images.icons.eyeClose,
    onBlur: handleBlur,
    onChange: handleChange,
    onClick: handleShowPassword,
    touched: props?.formik?.touched,
    type: type,
  };

  function handleShowPassword(event) {
    event.preventDefault();
    type === "password" ? setType("text") : setType("password");
  }

  function handleBlur(event) {
    if (!passReq.find((message) => !message.passed)) {
      setShowMessage(false);
    }
    props?.formik?.handleBlur(event);
  }

  async function handleChange(event) {
    props?.formik?.handleChange(event);

    const password = event.target.value;
    if (!password || event.target.name !== "password") return;

    let errors;
    await registerSchema.validate({ password }, { abortEarly: false }).catch((err) => (errors = err.errors));

    const updatedPassReq = passReq.map((requirement) => {
      if (errors?.includes(requirement.message)) {
        return { ...requirement, passed: false };
      }
      return { ...requirement, passed: true };
    });

    setPassReq(updatedPassReq);
  }

  function getPassRequirements() {
    if (!showMessage) {
      return null;
    }

    return (
      <ul className="text-sm mt-1">
        {passReq.map((requirement) => (
          <div className="flex items-center mb-1" key={requirement.message}>
            <div
              className={`h-3 w-3 rounded-full mr-2 transition-all ${
                requirement.passed ? "bg-green-500" : "bg-orange-500"
              }`}
            ></div>
            <li>{requirement.message}</li>
          </div>
        ))}
      </ul>
    );
  }

  return (
    <React.Fragment>
      <div>
        <FieldInput
          {...defaultProps}
          {...props}
          name="password"
          placeholder={translate("forms.master_password.placeholder")}
          onFocus={() => setShowMessage(true)}
          value={props?.formik.values?.password}
        />

        {getPassRequirements()}
      </div>

      <FieldInput
        {...defaultProps}
        {...props}
        name="confirmPassword"
        placeholder={translate("forms.master_password.confirm_password.placeholder")}
        value={props?.formik.values?.confirmPassword}
        errors={props.formik.errors}
      />

      <div>
        <FieldInput
          {...props}
          name="passwordHint"
          onChange={props.formik?.handleChange}
          placeholder={translate("forms.master_password.hint.placeholder")}
          required={false}
          value={props?.formik.values?.passwordHint}
        />
        <p className="text-sm mt-1">{translate("forms.master_password.hint.message")}</p>
      </div>
    </React.Fragment>
  );
};

export default MasterPassword;
